export function getPronoun(gender) {
	if (gender === 'm') {
		return 'han';
	} else if (gender === 'f') {
		return 'hon';
	}
	return 'hen';
}
